import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=86545e4e&"
import script from "./edit.js?vue&type=script&lang=js&"
export * from "./edit.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports